var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedeemToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6282 106C9.19126 106.028 7.40738 104.494 7.17977 101.583C6.41159 91.7329 5.72876 81.8742 4.99472 72.0211C4.0786 59.738 3.1454 47.4577 2.22074 35.1745C1.48386 25.3921 0.738438 15.6097 0.0129348 5.82445C-0.140701 3.73346 1.08839 2.49583 2.94909 2.06633C4.5708 1.69334 6.2864 1.64813 7.96502 1.6114C17.8688 1.39947 27.7755 1.26667 37.6793 1.04627C51.9333 0.726968 66.1902 0.359633 80.4442 0.00360044C83.1072 -0.0642153 84.4558 0.817389 85.2752 3.37743C92.3794 25.5673 99.4751 47.76 106.554 69.9584C107.635 73.3463 106.81 74.8496 103.438 75.9714C73.9801 85.7679 44.5218 95.5645 15.0607 105.35C14.0735 105.677 13.0492 105.889 12.6282 106Z",
    fill: "#385E8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1995 28H51.7995C45.2553 28 42.3992 30.4647 42.0538 36.4862C42.0219 37.0422 42.4745 37.5 43.0314 37.5H48.1995C56.5995 37.5 60.4995 41.4 60.4995 49.8V54.9681C60.4995 55.525 60.9573 55.9776 61.5133 55.9457C67.5348 55.6003 69.9995 52.7442 69.9995 46.2V37.8C69.9995 30.8 67.1995 28 60.1995 28Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2 40H39.8C32.8 40 30 42.8 30 49.8V58.2C30 65.2 32.8 68 39.8 68H48.2C55.2 68 58 65.2 58 58.2V49.8C58 42.8 55.2 40 48.2 40ZM50.58 51.3L43.16 58.72C42.88 59 42.52 59.14 42.14 59.14C41.76 59.14 41.4 59 41.12 58.72L37.4 55C36.84 54.44 36.84 53.54 37.4 52.98C37.96 52.42 38.86 52.42 39.42 52.98L42.12 55.68L48.54 49.26C49.1 48.7 50 48.7 50.56 49.26C51.12 49.82 51.14 50.74 50.58 51.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemToken);
export default __webpack_public_path__ + "static/media/redeemToken.ca4eeff8ba15d3ba0253c7b2c1fe22f4.svg";
export { ForwardRef as ReactComponent };